import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MenuAccessService } from '@app/Services/menu-access.service';

@Injectable({
    providedIn: 'root',
})
export class MenuEnvGuard implements CanActivate, CanActivateChild {
    constructor(
        private readonly menuAccess: MenuAccessService,
        private readonly router: Router,
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.checkAccess(state.url);
    }

    canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.checkAccess(state.url);
    }

    private checkAccess(url: string): boolean | UrlTree {
        if (this.menuAccess.isPathAllowed(url)) {
            return true;
        }
        return this.router.createUrlTree(['/new-data-explorer']);
    }
}
